module.exports = tribe.events.blocks;